import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux.toolkit/store';

export const selectUser = (state: RootState) => state.user.user;
export const selectInfoUser = (state: RootState) => state.user.infoUser;
export const selectToken = (state: RootState) => state.user.token;
export const selectActiveUser = (state: RootState) => state.user.activeUser;
export const selectOnlineCount = (state: RootState) => state.user.onlineCount;

export const selectUserState = createSelector(
  [
    selectUser,
    selectInfoUser,
    selectToken,
    selectActiveUser,
    selectOnlineCount,
  ],
  (userConnected, infoUser, token, activeUser, onlineCount) => ({
    userConnected,
    infoUser,
    token,
    activeUser,
    onlineCount,
  }),
);
